export { Device } from './device';
